





















import {
    Component, Prop, Vue, ComponentStyle, ComponentStyleDefinition
} from "@zoovu/runner-browser-api";

@Component({})
export default class Modal extends Vue {

    @Prop()
    status: false;

    @Prop()
    type: 'default';

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    onClose() {
        this.$emit('close-modal')
    }
}
